import { callable } from '@/utils/serverless'

export default {
  install: () => {
    setup_error_handlers()
  }
}

const track_error = async (error: Error | string, context = {}) => {
  const error_data = {
    message: error instanceof Error ? error.message : error,
    stack: error instanceof Error ? error.stack : undefined,
    context,
    timestamp: new Date().toISOString()
  }
  console.error(error_data)
  try {
    await callable('error')(error_data)
  } catch (e) {
    console.error('Failed to log error:', e)
  }
}

// Global error handlers
const setup_error_handlers = () => {
  // eslint-disable-next-line max-params
  window.onerror = (message, source, lineno, colno, error) => {
    void track_error(error || message, { source, lineno, colno })
    return false // Let error propagate to console
  }

  window.onunhandledrejection = event => {
    void track_error(event.reason, { type: 'unhandledRejection' })
  }
}
